import * as React from 'react'

function SvgBe(props) {
	return (
		<svg viewBox="0 0 450 390" width="1em" height="1em" {...props}>
			<path fill="#ED2939" d="M0 0h450v390H0z" />
			<path fill="#FAE042" d="M0 0h300v390H0z" />
			<path d="M0 0h150v390H0z" />
		</svg>
	)
}

export default SvgBe
